import { atom } from 'jotai';
import { Comment_Base } from '~/common/typescript/models/Comment';

export const allowAddCommentOnMapAtom = atom<boolean>(false);

export const commentsAtom = atom<Comment_Base[]>([]);

export const showCommentOnMapAtom = atom<boolean>(true);

export const commentDisplayedBoundsAtom = atom<string | null>(null);

export const newlyCreatedCommentIdAtom = atom<number | null>(null);

export const showCommentLabelsAtom = atom<boolean>(true); // Temporarily true for testing
